import type { ComponentWithAs, IconProps } from '@chakra-ui/react';
import { Center, Text } from '@chakra-ui/react';

import { Option } from '@revelio/ui';

type SelectionOptionCardProps = {
  testId: string;
  label: string;
  description: string;
  icon: ComponentWithAs<'svg', IconProps>;
  isDisabled: boolean;
  isSelected: boolean;
  onClick?: () => void;
};

export const SelectionOptionCard = ({
  testId,
  label,
  description,
  icon: IconComponent,
  isDisabled,
  isSelected,
  onClick,
}: SelectionOptionCardProps) => {
  return (
    <Option
      data-testid={testId}
      disabled={isDisabled}
      isSelected={isSelected}
      onClick={onClick}
      style={{
        borderStyle: isDisabled ? 'dashed' : 'solid',
        minHeight: 0,
        height: '100%',
      }}
      startSlot={
        <Center w={12} h={12} borderRadius="full" bg="gray.100">
          <IconComponent boxSize={6} color="gray.600" />
        </Center>
      }
    >
      <Text fontWeight="semibold" fontSize="sm">
        {label}
      </Text>
      <Text fontSize="xs" color="gray.500" mt={0.5}>
        {description}
      </Text>
    </Option>
  );
};
